module.exports = __webpack_public_path__ + "img/shop-6pm.f1497a4f.png";